import $ from "jquery"
import MultiSelect from "../coreui/multi-select"
import { syncMultiSelect } from "./multi_select"

const lengthSelects = (settings) => settings.nTableWrapper?.querySelectorAll(".dataTables_length select") || []

// DataTables owns the native select and its change handler. Add the same stable
// Stimulus owner used by Rails fields without replacing that native element.
$(document).on("init.dt", (_event, settings) => {
  const template = document.getElementById("data-table-page-size-template")
  if (!template) return

  lengthSelects(settings).forEach((select, index) => {
    if (select.closest('[data-controller~="coreui-multi-select"]')) return

    const owner = template.content.firstElementChild.cloneNode(true)
    const host = owner.querySelector("select")
    select.id ||= `${settings.sTableId}-page-size-${index}`
    select.classList.remove("form-select", "form-select-sm", "form-control", "form-control-sm")
    select.classList.add("form-multi-select", "form-multi-select-sm")
    Object.assign(select.dataset, host.dataset)
    select.before(owner)
    host.replaceWith(select)
  })
})

// DataTables also changes page length through its API, without a native change
// event. Keep the rendered value synchronized with those updates.
$(document).on("length.dt", (_event, settings) => {
  lengthSelects(settings).forEach((select) => {
    if (!MultiSelect.getInstance(select)?.dispatchingChange) syncMultiSelect(select)
  })
})
